import React from 'react';
import { AINavigationContainer } from '../../private/containers/AINavigationContainer';

export const SlAINavigation = () => {
  return <AINavigationContainer />;
};